import React, { Fragment, useMemo } from 'react';

import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import TrackItem from 'components/TrackItem';
import { Visibility } from 'components/Visibility';

import logoOnlife from "img/logo-onlife.svg";

import { TrackingOrderProps } from './interface';

import { isMobileDevice } from 'utils/ScreenUtils';
import { DateOutputStr } from 'utils/DateOutput';
import { IDomainSetting } from 'models/DomainSetting';

export const TrackingOrder: React.FC<TrackingOrderProps> = (props) => {
  const {
    shippingCompanyName,
    trackingTypes,
    lastItemWithDate,
    expectedDeliveryDate,
    isGreenDelivery = false
  } = props;

  const isMobile = isMobileDevice();

  const renderItems = () => {
    const renderTrackItem = (item: IDomainSetting, index: number) => (
      <Fragment key={item.id}>
        <TrackItem
          indexCurrentItem={index}
          item={item}
          lastItemWithDate={lastItemWithDate}
          trackingTypes={trackingTypes}
        />
        {!isMobile && index !== trackingTypes.length - 1 && <Column className="icon-track-item" />}
      </Fragment>
    );

    return useMemo(() => (
      trackingTypes.map(renderTrackItem)
    ), [trackingTypes, isMobile]);
  };

  const renderTrackingDefault = () => {
    return (
      <Row
        className="tracking-item mt-3 mb-1 pb-2 mx-auto bg-white w-100 px-3 align-start justify-between overflow-x-auto"
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        {renderItems()}
      </Row>
    );
  };

  const renderTrackingMobile = () => {
    return (
      <div
        className="tracking-item mt-3 mb-1 pb-2 mx-auto bg-white w-100 px-3 align-center justify-center"
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        {renderItems()}
      </div>
    );
  };

  const renderTracking = () => {
    if (isMobile) {
      return renderTrackingMobile();
    }

    return renderTrackingDefault();
  };

  return (
    <Column className="mb-1">
      <Row className='justify-between flex-lg-column align-center align-lg-none'>
        <Row>
          <Text className="font-bold color-blue-gray mt-2 mb-1" size={12} width={isMobile ? "45%" : undefined}>

            Tracking do pedido
            {shippingCompanyName && shippingCompanyName !== '' && !isMobile && ` (Entregue por ${shippingCompanyName})`}
          </Text>
          <Visibility visible={!!expectedDeliveryDate && isMobile}>
            <Text className="mt-2 mb-1 expected-delivery-label align-center" size={12} width="55%" showTip>
              Previsão de entrega {DateOutputStr(expectedDeliveryDate, 'dd/MM/yyyy')}
            </Text>
          </Visibility>
        </Row>

        <Visibility visible={isGreenDelivery && !isMobile}>
          <Row className='grid-gap-2'>
            <Text className="d-block color-blue-gray mt-2 mb-1 font-italic" size={12}>
              Esse pedido foi entregue usando nossa frota de veículos elétricos
            </Text>
            <img src={logoOnlife} alt="Logo Onlife" />
          </Row>
        </Visibility>
      </Row>

      {renderTracking()}
    </Column>
  );
};